import api from "@/api.js";
import apiV2 from "@/apiV2";

export default {
  namespaced: true,
  modules: {},
  state: {
    list: [],
    listLoading: false,
    selectedData: null,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedData(state, payload) {
      state.selectedData = payload;
    },
  },
  actions: {
    // async loadAllByOutcomesIDAndYear({ commit }, payload) {
    //   commit("setListLoading", true);
    //   let list = await api.get("/sources/data/byOutcomesIDAndYear", {
    //     params: { id: payload.id, year: payload.year },
    //   });
    //   commit("setList", list.data);
    //   commit("setListLoading", false);
    // },
    async loadAllByOutcomesIDAndYear({ commit }, payload) {
      commit("setListLoading", true);

      let list = await apiV2.get("/SourceData/ForOutcome", {
        params: {
          sustainabilityBusinessId: payload.sustainabilityBusinessId,
          outcomeId: payload.outcomeId,
          startingMonth: payload.startingMonth,
          finalMonth: payload.finalMonth,
        },
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadBySourceIDAndYear(
      { commit },
      { year: year, sourceId: sourceId }
    ) {
      commit("setListLoading", true);
      let list = await api.get("/sources/data/bySourceIDAndYear", {
        params: { id: sourceId, year: year },
      });
      commit("setSelectedData", list.data[0]);
      commit("setListLoading", false);
    },
    async loadAllByOutcomesIDAndYearWithGoals({ commit }, payload) {
      commit("setListLoading", true);
      let list = await api.get("/sources/data/byOutcomesIDAndYearWithGoals", {
        params: { id: payload.id, year: payload.year },
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadBySourceID({ commit }, params) {
      commit("setListLoading", true);
      let list = await api.get("/sources/data/bySourceID", {
        params: params,
      });
      commit("setSelectedData", list.data[0]);
      commit("setListLoading", false);
    },
    async updateSingleDataPoint({ dispatch }, payload) {
      let returnData = {};
      await apiV2.put("/SourceData/UpdateSingle", payload)
        .then((response) => {
          returnData = response.data;
        })
        .catch((err) => {
          returnData = {
            result: "Error",
            response: {
              message: "There was an error, please try again later",
            },
          };
        });
      return returnData;
    },
    async updateSingleDataPointNote({ dispatch }, payload) {
      let returnData = {};
      await apiV2.put("/SourceData/SetNoteForSingle", payload)
        .then((response) => {
          returnData = response.data;
        })
        .catch((err) => {
          returnData = {
            result: "Error",
            response: {
              message: "There was an error, please try again later",
            },
          };
        });
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("/sources/data", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedData(state) {
      return state.selectedData;
    },
  },
};
